import { UserRole } from '@repo/common/enums/UserRole';
import AddMonitorButton from '../../../components/AddMonitor/AddMonitorButton';
import { FeatureGuard } from '../../../components/FeatureGuard/FeatureGuard';
import { Guard } from '../../../components/Guard/Guard';
import MonitorList from '../../MonitorsPage/MonitorList';

interface IMonitorsTabProps {
	integrationId: string;
	tableId?: string;
	upstreamOf?: string;
	canCreateMonitors?: boolean;
}

function MonitorsTab({
	integrationId,
	tableId,
	upstreamOf,
	canCreateMonitors = true,
}: IMonitorsTabProps) {
	const searchParams = upstreamOf
		? { upstream_of: upstreamOf }
		: { target_id: tableId };

	// Determine if we should show the create button
	// For table view: show if canCreateMonitors is true and tableId is provided
	// For upstream view: show if canCreateMonitors is true and upstreamOf is provided
	const showCreateButton = canCreateMonitors && (tableId || upstreamOf);

	return (
		<FeatureGuard
			featureName="Monitors"
			description="Add monitors to your data, set thresholds, and be alerted as soon as incidents are detected."
			v1AllowedRoles={[
				UserRole.ADMIN,
				UserRole.EDITOR,
				UserRole.VIEWER,
				UserRole.GUEST,
			]}
			v2Permission="Monitors.Read"
			isFeatureIncludedInPlan={true}
			isAlwaysIncludedFeature={true}
		>
			<MonitorList
				defaultRequiredSearchParams={searchParams}
				withAdditionalButtons={
					showCreateButton && (
						<Guard
							v1AllowedRoles={[UserRole.ADMIN, UserRole.EDITOR]}
							v2Permission="Monitors.Create"
						>
							<AddMonitorButton
								// Don't pass initialIntegration when upstreamOf is provided,
								// as upstream entities may be from different integrations
								initialIntegration={upstreamOf ? undefined : integrationId}
								initialTable={tableId}
								upstreamOf={upstreamOf}
							/>
						</Guard>
					)
				}
			/>
		</FeatureGuard>
	);
}

export default MonitorsTab;
